// @ts-nocheck
import * as Types from '../../types/types';

import * as Operations from '../../queries';
import * as Apollo from '@apollo/client/react';
const defaultOptions = {} as const;
export type CollectManualPersonConsentMutationVariables = Types.Exact<{
  oid: Types.Scalars['PersonConsentId']['input'];
  consentTypeId: Types.Scalars['ConsentTypeId']['input'];
  issuerPersonId: Types.Scalars['PersonId']['input'];
  signerPersonId: Types.Scalars['PersonId']['input'];
  actionAt: Types.Scalars['DateTime']['input'];
  consentItemsValues:
    | Array<Types.PersonConsentItemValueInput>
    | Types.PersonConsentItemValueInput;
  manualProcessReason: Types.Scalars['ConsentTypeManualProcessReasonId']['input'];
}>;

export type CollectManualPersonConsentMutation = {
  __typename?: 'Mutation';
  collectManualPersonConsent?: {
    __typename?: 'PersonConsent';
    id: string;
    oid?: string | null;
  } | null;
};

export type CollectManualPersonConsentMutationFn = Apollo.MutationFunction<
  CollectManualPersonConsentMutation,
  CollectManualPersonConsentMutationVariables
>;

/**
 * __useCollectManualPersonConsentMutation__
 *
 * To run a mutation, you first call `useCollectManualPersonConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCollectManualPersonConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [collectManualPersonConsentMutation, { data, loading, error }] = useCollectManualPersonConsentMutation({
 *   variables: {
 *      oid: // value for 'oid'
 *      consentTypeId: // value for 'consentTypeId'
 *      issuerPersonId: // value for 'issuerPersonId'
 *      signerPersonId: // value for 'signerPersonId'
 *      actionAt: // value for 'actionAt'
 *      consentItemsValues: // value for 'consentItemsValues'
 *      manualProcessReason: // value for 'manualProcessReason'
 *   },
 * });
 */
export function useCollectManualPersonConsentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CollectManualPersonConsentMutation,
    CollectManualPersonConsentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CollectManualPersonConsentMutation,
    CollectManualPersonConsentMutationVariables
  >(Operations.collectManualPersonConsent, options);
}
export type CollectManualPersonConsentMutationHookResult = ReturnType<
  typeof useCollectManualPersonConsentMutation
>;
export type CollectManualPersonConsentMutationResult =
  Apollo.MutationResult<CollectManualPersonConsentMutation>;
export type CollectManualPersonConsentMutationOptions =
  Apollo.BaseMutationOptions<
    CollectManualPersonConsentMutation,
    CollectManualPersonConsentMutationVariables
  >;
